"use strict";

import {onEnterViewPort} from "@elements/viewport-utils";
import {getPrefixedDataSet} from "@elements/data-set-utils";
import {onFind} from "@elements/init-modules-in-scope";
import {setAttribute} from "@elements/dom-utils";


const defaultSelectors = {
    base: '.js-lazy-iframe'
};

const defaultOptions = {
    offset: window.innerHeight / 2,
    preventNative: false
};

export function init(options = defaultOptions, selectors = defaultSelectors, scope = document.body) {
    onFind(selectors.base, function (baseElement) {
        createLazyIframe(
            baseElement,
            {...defaultOptions, ...options},
            {...defaultSelectors, ...selectors}
        );
    }, scope);
}

export function createLazyIframe(iframe, options = defaultOptions, selectors = defaultSelectors) {
    options = {
        ...defaultOptions,
        ...options,
        ...getPrefixedDataSet('lazy-iframe', iframe)
    };

    if ('loading' in HTMLImageElement.prototype && !options.preventNative) {
        switchIframe(iframe, true)
    } else {
        onEnterViewPort(iframe, function (iframe) {
            switchIframe(iframe);
        }, options);
    }
}

export function loadIframe(iframe) {
    switchIframe(iframe);
}

function switchIframe(iframe, addLazyLoading = false) {
    if (addLazyLoading) {
        setAttribute('loading', 'lazy', iframe);
    }

    if (iframe.dataset.src) {
        setAttribute('src', iframe.dataset.src, iframe);
    }
}
